document.addEventListener('DOMContentLoaded', () => {
  const isOutbound = (url) => {
    try {
      const componentUrl = new URL(url)
      return componentUrl.host.replace('assets.', '') !== window.location.host
    } catch (error) {
      return false
    }
  }

  const navigation = document.querySelectorAll('.menu-nav')
  navigation.forEach((element) => {
    element.addEventListener('click', () => {
      if (window.innerWidth <= 1280) {
        return
      }

      const menuTitle = element
        .closest('.dropdown')
        ?.querySelector('.dropdown__title')
        ?.getAttribute('title')
      window.dataLayer.push({
        event: 'navigation',
        label: `${menuTitle} - ${element.getAttribute('title')}`,
      })
    })
  })

  const navigationMobile = document.querySelectorAll('.accordion__item')
  navigationMobile.forEach((element) => {
    element.addEventListener('click', (event) => {
      const clickedItem = event.target
      if (clickedItem.tagName === 'A') {
        const menuTitle = element.querySelector(
          '.accordion__item-title'
        ).innerText
        const menuItem = clickedItem.innerText
        window.dataLayer.push({
          event: 'navigation',
          label: `${menuTitle} - ${menuItem}`,
        })
      }
    })
  })

  const navigationElements = document.querySelectorAll('.topnav a')
  navigationElements.forEach((element) => {
    element.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'click',
        section: 'header',
        label: element.getAttribute('title'),
      })
    })
  })

  const navigationMobileElements = document.querySelectorAll(
    '.menu_mobile_tagging'
  )
  navigationMobileElements.forEach((element) => {
    const navigationMobileTitleElement = element.querySelector(
      '.accordion__item-title a'
    )
    navigationMobileTitleElement.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'click',
        section: 'header',
        label: navigationMobileTitleElement.innerText,
      })
    })

    const navigationMobileChildElement = element.querySelector('.sub-ul li a')
    if (navigationMobileChildElement) {
      navigationMobileChildElement.addEventListener('click', () => {
        window.dataLayer.push({
          event: 'click',
          section: 'header',
          label: navigationMobileChildElement.innerText,
        })
      })
    }
  })

  const languageElements = document.querySelectorAll('.language a')
  languageElements.forEach((element) => {
    element.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'click',
        section: 'language',
        label: element.getAttribute('title'),
      })
    })
  })

  const downloadElements = document.querySelectorAll('.download-link')
  downloadElements.forEach((element) => {
    if (
      element.getAttribute('file_extension')
      && element.getAttribute('file_name')
      && element.getAttribute('link_url')
    ) {
      element.addEventListener('click', () => {
        window.dataLayer.push({
          event: 'file_download',
          file_extension: element.getAttribute('file_extension'),
          file_name: element.getAttribute('file_name'),
          link_url: element.getAttribute('link_url'),
        })
      })
    }
  })

  const accordionElements = document.querySelectorAll(
    '.accordion:not(.items-menu-container) .accordion__item'
  )
  accordionElements.forEach((element) => {
    element.addEventListener('click', () => {
      const event = element.classList.contains('accordion__item--open')
        ? 'abrir'
        : 'fechar'
      const name = element.querySelector('.accordion__item-title').innerText
      window.dataLayer.push({
        event: 'click',
        name: `${event}-${name}`,
        section: 'Tire suas duvidas',
        component_type: 'accordion',
        outbound: false,
      })
    })
  })

  // Banner dynamic Tagging
  const banners = document.querySelectorAll('.banner-dynamic__content')
  banners.forEach((banner) => {
    const button = banner.querySelector('.actions a')
    button.addEventListener('click', () => {
      const title = banner.querySelector('.banner-dynamic__title')
      const section = banner.querySelector('.banner-dynamic__section')
      window.dataLayer.push({
        event: 'click',
        name: title ? title.innerText : '',
        section: section ? section.value : '',
        component_type: 'botao',
        link_url: button.href,
        outbound: isOutbound(button.href),
      })
    })
  })

  const shareElements = document.querySelectorAll('.share-social')
  shareElements.forEach((element) => {
    element.addEventListener('click', () => {
      const linkUrl = element
        .closest('.share-download-link')
        .getAttribute('content-download-url')
      window.dataLayer.push({
        event: 'share',
        section: 'Download Link',
        link_url: linkUrl,
        method: element.getAttribute('id').replace('link-share-', ''),
        component_type: 'logo',
      })
    })
  })

  const footer = document.querySelector('footer')
  if (footer) {
    const trackClick = (outbound, label) => {
      window.dataLayer.push({
        event: 'click',
        section: 'footer',
        outbound,
        label,
      })
    }

    footer.querySelectorAll('.footer-links').forEach((column) => {
      const columnName = column.querySelector('a')?.innerText || ''
      column.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          trackClick(isOutbound(link.href), `${columnName}-${link.innerText}`)
        })
      })
    })

    const nbIcon = footer.querySelector('.external-link')
    const nbIconLabel = nbIcon.querySelector('span').innerText
    const nbIconHref = nbIcon.querySelector('a').getAttribute('href')

    nbIcon.addEventListener('click', () => {
      trackClick(isOutbound(nbIconHref), nbIconLabel)
    })

    footer.querySelectorAll('.social-icon').forEach((icon) => {
      const iconAlt = icon.getAttribute('alt')
      const linkHref = icon.closest('a')?.getAttribute('href') || ''
      icon.addEventListener('click', () => {
        trackClick(isOutbound(linkHref) || isOutbound(nbIconHref), iconAlt || linkHref || nbIconLabel)
      })
    })
  }

  const dataSectionElement = document.querySelector('[data-section]')
  const getDataSection = dataSectionElement?.getAttribute('data-section')
  const dataSectionButton = dataSectionElement?.querySelector('a').innerText

  if (getDataSection === 'Qualidade CBMM') {
    dataSectionElement.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'click',
        section: getDataSection || '',
        label: dataSectionButton || '',
        outbound: isOutbound(dataSectionButton),
      })
    })
  }

  window.pushButtonGTM = (name, section, componentType, linkUrl) => {
    window.dataLayer.push({
      event: 'click',
      name,
      section,
      component_type: componentType,
      link_url: linkUrl,
      outbound: isOutbound(linkUrl),
    })
  }
})
